import { render, staticRenderFns } from "./UserAddForm.vue?vue&type=template&id=bc2326c8"
import script from "./UserAddForm.vue?vue&type=script&lang=js"
export * from "./UserAddForm.vue?vue&type=script&lang=js"
import style0 from "./UserAddForm.vue?vue&type=style&index=0&id=bc2326c8&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports